var _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3977 24.7382C12.5363 24.5996 12.7269 24.5188 12.929 24.5188H31.2581C31.5931 24.5188 31.7605 24.923 31.5238 25.1598L27.903 28.7806C27.7644 28.9192 27.5738 29 27.3717 29H9.04254C8.7076 29 8.54013 28.5958 8.7769 28.359L12.3977 24.7382Z",
    fill: "url(#paint0_linear_1061_24254)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3977 11.2194C12.5421 11.0808 12.7326 11 12.929 11H31.2581C31.5931 11 31.7605 11.4042 31.5238 11.641L27.903 15.2618C27.7644 15.4004 27.5738 15.4812 27.3717 15.4812H9.04254C8.7076 15.4812 8.54013 15.077 8.7769 14.8402L12.3977 11.2194Z",
    fill: "url(#paint1_linear_1061_24254)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.903 17.9355C27.7644 17.7969 27.5738 17.7161 27.3717 17.7161H9.04254C8.7076 17.7161 8.54013 18.1203 8.7769 18.3571L12.3977 21.9779C12.5363 22.1164 12.7269 22.1973 12.929 22.1973H31.2581C31.5931 22.1973 31.7605 21.7931 31.5238 21.5563L27.903 17.9355Z",
    fill: "url(#paint2_linear_1061_24254)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1061_24254",
    x1: -32.7611,
    y1: 7.59961,
    x2: -33.2488,
    y2: 32.1393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1061_24254",
    x1: -38.3078,
    y1: 4.70375,
    x2: -38.7954,
    y2: 29.2435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1061_24254",
    x1: -35.5521,
    y1: 6.14243,
    x2: -36.0398,
    y2: 30.6822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/sol.b940c8e145cb2b270a0f0e7501f07dd1.svg";
export { ForwardRef as ReactComponent };